/** Small monospace wordmark: lowercase "kaption" with an accent-colored k. */
export function Logo({ size = 15 }: { size?: number }) {
  return (
    <span className="logo" style={{ fontSize: size }}>
      <span className="logo-k">k</span>aption
    </span>
  );
}
